/* global ga */
Wee.fn.make('common', {
	init: function() {
		var priv = this.$private;

		// Arrange footer
		$.screen.map([
			{
				max: 3,
				callback: function() {
					priv.arrangeFooter('mobile');
				}
			},
			{
				min: 4,
				callback: function() {
					priv.arrangeFooter('desktop');
				}
			}
		]);

		// Wee history
		$.history.init({
			bind: {
				click: 'a'
			},
			request: {
				success: function() {
					ga('send', 'pageview');
				},
				error: function(xhr) {
					$._win.location = xhr.responseURL;
				}
			}
		});

		// Disable mouse event outlines
		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';

				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: $._body
		});
	},

	unload: function() {
		Wee.events.off(false, 'click.icon');
	}
}, {
	/**
	 * Arrange footer based on breakpoint
	 *
	 * @private
	 * @param {string} breakpoint
	 */
	arrangeFooter: function(breakpoint) {
		var $inner = $('ref:footerInner'),
			$contact = $('ref:siteContactFooter'),
			$info = $('ref:footerInfo');

		if (breakpoint === 'mobile') {
			$inner.prepend($contact)
				.append($info);
		} else {
			$inner.append($contact)
				.prepend($info);
		}
	}
});